/* eslint-disable spire/export-styles */
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import { HasHistory } from "@insite/mobius/utilities/HistoryContext";
import { generateLinksFrom } from "@tCooneyBrothers/Overrides/Components/PageBreadcrumbs";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    return {
        breadcrumbLinks: state.components.breadcrumbs.links,
        linksState: state.links,
        nodeId: getCurrentPage(state).nodeId,
        productsDataView: state.data.products,
    };
};
type Props = HasHistory & WidgetProps & ReturnType<typeof mapStateToProps> & HasCategoryContext;

const CustomPageTitle: React.FunctionComponent<Props> = ({ category, breadcrumbLinks, linksState, nodeId, productsDataView }: Props) => {
    const categoryTitle =
        breadcrumbLinks?.[breadcrumbLinks?.length - 1].children || generateLinksFrom(linksState, nodeId);

    const links = breadcrumbLinks || generateLinksFrom(linksState, nodeId);
    const brandName = links[1]?.children === "brands" ? links[2]?.children ? links[2]?.children.toString().replace(/(™|®|©)/g,"") : "" : "";

    if (!category) {
        return (
            <Typography variant="h1" size="32px">
                {links[1]?.children === "brands" && links[3]?.children === "Shop All Products" ? (
                    <>{links[2]?.children}</>
                ) : (
                    categoryTitle
                )}
            </Typography>
        );
    }

    return (
        <Typography variant="h1" size="32px">
            {brandName} {category.shortDescription}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withCategory(connect(mapStateToProps, undefined)(CustomPageTitle)),
    definition: {
        group: "Categories",
        icon: "PageTitle",
    },
};

export default widgetModule;
